import { createReducer, createActions } from 'reduxsauce';
import Immutable from 'seamless-immutable';

export const INITIAL_STATE = Immutable({
  isLoading: {},
  lastRequest: null,
  successMessage: null,
  errorMessage: null,
  controllers: [],
  totalElements: 0,
  fileName: null,
  controllerDetails: null,
  customers: null,
});

const { Types, Creators } = createActions({
  getControllersRequest: ['pageParams'],
  getControllersRequestSuccess: ['controllers', 'totalElements'],
  getControllersRequestFailure: ['errorMessage'],

  getControllerDetailsRequest: ['controllerId'],
  getControllerDetailsRequestSuccess: ['controllerDetails'],
  getControllerDetailsRequestFailure: ['errorMessage'],

  editControllerRequest: ['controllerId', 'controllerInfos', 'pageParams'],
  editControllerRequestSuccess: ['controllers', 'totalElements', 'successMessage'],
  editControllerRequestFailure: ['errorMessage'],

  editControllerSettingsRequest: ['controllerId', 'controllerSettings'],
  editControllerSettingsRequestSuccess: ['controllerDetails', 'successMessage'],
  editControllerSettingsRequestFailure: ['errorMessage'],

  deleteControllerRequest: ['controllerId', 'pageParams'],
  deleteControllerRequestSuccess: ['controllers', 'totalElements', 'successMessage'],
  deleteControllerRequestFailure: ['errorMessage'],

  resetControllers: null,
  resetFile: null,

  uploadFileRequest: ['file'],
  uploadFileRequestSuccess: ['fileName', 'successMessage'],
  uploadFileRequestFailure: ['errorMessage'],

  updateControllersRequest: ['body'],
  updateControllersRequestSuccess: ['successMessage'],
  updateControllersRequestFailure: ['errorMessage'],

  getCustomersForControllerRequest: ['distributorId'],
  getCustomersForControllerRequestSuccess: ['customers'],
  getCustomersForControllerRequestFailure: ['errorMessage'],
});

export const getControllersRequest = (state) =>
  state.merge({
    isLoading: true,
    errorMessage: null,
    successMessage: null,
    lastRequest: 'GET_CONTROLLERS_REQUEST',
  });
export const getControllersRequestSuccess = (state, { controllers, totalElements }) =>
  state.merge({
    isLoading: false,
    controllers,
    totalElements,
  });
export const getControllersRequestFailure = (state, { errorMessage }) =>
  state.merge({
    isLoading: false,
    errorMessage,
  });

export const getControllerDetailsRequest = (state) =>
  state.merge({
    isLoading: true,
    errorMessage: null,
    successMessage: null,
    lastRequest: 'GET_CONTROLLER_DETAILS_REQUEST',
  });
export const getControllerDetailsRequestSuccess = (state, { controllerDetails }) =>
  state.merge({
    isLoading: false,
    controllerDetails,
  });
export const getControllerDetailsRequestFailure = (state, { errorMessage }) =>
  state.merge({
    isLoading: false,
    errorMessage,
  });

export const editControllerSettingsRequest = (state) =>
  state.merge({
    isLoading: true,
    errorMessage: null,
    successMessage: null,
    lastRequest: 'EDIT_CONTROLLER_SETTINGS_REQUEST',
  });
export const editControllerSettingsRequestSuccess = (state, { controllerDetails, successMessage }) =>
  state.merge({
    isLoading: false,
    controllerDetails,
    successMessage,
  });
export const editControllerSettingsRequestFailure = (state, { errorMessage }) =>
  state.merge({
    isLoading: false,
    errorMessage,
  });

export const editControllerRequest = (state) =>
  state.merge({
    isLoading: true,
    errorMessage: null,
    successMessage: null,
    lastRequest: 'EDIT_CONTROLLER_REQUEST',
  });
export const editControllerRequestSuccess = (state, { controllers, totalElements, successMessage }) =>
  state.merge({
    isLoading: false,
    controllers,
    totalElements,
    successMessage,
  });
export const editControllerRequestFailure = (state, { errorMessage }) =>
  state.merge({
    isLoading: false,
    errorMessage,
  });

export const deleteControllerRequest = (state) =>
  state.merge({
    isLoading: true,
    errorMessage: null,
    successMessage: null,
    lastRequest: 'DELETE_CONTROLLER_REQUEST',
  });
export const deleteControllerRequestSuccess = (state, { controllers, totalElements, successMessage }) =>
  state.merge({
    isLoading: false,
    controllers,
    totalElements,
    successMessage,
  });
export const deleteControllerRequestFailure = (state, { errorMessage }) =>
  state.merge({
    isLoading: false,
    errorMessage,
  });

export const resetControllers = (state) => state.merge({ controllers: [], totalElements: 0 });
export const resetFile = (state) => state.merge({ fileName: null });

export const uploadFileRequest = (state) =>
  state.merge({
    isLoading: true,
    errorMessage: null,
    successMessage: null,
    lastRequest: 'UPLOAD_FILE_REQUEST',
  });
export const uploadFileRequestSuccess = (state, { fileName, successMessage }) =>
  state.merge({
    fileName,
    isLoading: false,
    successMessage,
  });
export const uploadFileRequestFailure = (state, { errorMessage }) =>
  state.merge({
    isLoading: false,
    errorMessage,
  });

export const updateControllersRequest = (state) =>
  state.merge({
    isLoading: true,
    errorMessage: null,
    successMessage: null,
    lastRequest: 'UPDATE_CONTROLLERS_REQUEST',
  });
export const updateControllersRequestSuccess = (state, { successMessage }) =>
  state.merge({
    isLoading: false,
    successMessage,
  });
export const updateControllersRequestFailure = (state, { errorMessage }) =>
  state.merge({
    isLoading: false,
    errorMessage,
  });

export const getCustomersForControllerRequest = (state, { distributorId }) =>
  state.merge({
    isLoading: true,
    errorMessage: null,
    lastRequest: 'GET_CUSTOMERS_FOR_CONTROLLER_REQUEST',
  });
export const getCustomersForControllerRequestSuccess = (state, { customers }) =>
  state.merge({ customers, isLoading: false });
export const getCustomersForControllerRequestFailure = (state, { errorMessage }) =>
  state.merge({
    isLoading: false,
    errorMessage,
  });

export const reducer = createReducer(INITIAL_STATE, {
  [Types.GET_CONTROLLERS_REQUEST]: getControllersRequest,
  [Types.GET_CONTROLLERS_REQUEST_SUCCESS]: getControllersRequestSuccess,
  [Types.GET_CONTROLLERS_REQUEST_FAILURE]: getControllersRequestFailure,

  [Types.GET_CONTROLLER_DETAILS_REQUEST]: getControllerDetailsRequest,
  [Types.GET_CONTROLLER_DETAILS_REQUEST_SUCCESS]: getControllerDetailsRequestSuccess,
  [Types.GET_CONTROLLER_DETAILS_REQUEST_FAILURE]: getControllerDetailsRequestFailure,

  [Types.EDIT_CONTROLLER_REQUEST]: editControllerRequest,
  [Types.EDIT_CONTROLLER_REQUEST_SUCCESS]: editControllerRequestSuccess,
  [Types.EDIT_CONTROLLER_REQUEST_FAILURE]: editControllerRequestFailure,

  [Types.EDIT_CONTROLLER_SETTINGS_REQUEST]: editControllerSettingsRequest,
  [Types.EDIT_CONTROLLER_SETTINGS_REQUEST_SUCCESS]: editControllerSettingsRequestSuccess,
  [Types.EDIT_CONTROLLER_SETTINGS_REQUEST_FAILURE]: editControllerSettingsRequestFailure,

  [Types.DELETE_CONTROLLER_REQUEST]: deleteControllerRequest,
  [Types.DELETE_CONTROLLER_REQUEST_SUCCESS]: deleteControllerRequestSuccess,
  [Types.DELETE_CONTROLLER_REQUEST_FAILURE]: deleteControllerRequestFailure,

  [Types.RESET_CONTROLLERS]: resetControllers,
  [Types.RESET_FILE]: resetFile,

  [Types.UPLOAD_FILE_REQUEST]: uploadFileRequest,
  [Types.UPLOAD_FILE_REQUEST_SUCCESS]: uploadFileRequestSuccess,
  [Types.UPLOAD_FILE_REQUEST_FAILURE]: uploadFileRequestFailure,

  [Types.UPDATE_CONTROLLERS_REQUEST]: updateControllersRequest,
  [Types.UPDATE_CONTROLLERS_REQUEST_SUCCESS]: updateControllersRequestSuccess,
  [Types.UPDATE_CONTROLLERS_REQUEST_FAILURE]: updateControllersRequestFailure,

  [Types.GET_CUSTOMERS_FOR_CONTROLLER_REQUEST]: getCustomersForControllerRequest,
  [Types.GET_CUSTOMERS_FOR_CONTROLLER_REQUEST_SUCCESS]: getCustomersForControllerRequestSuccess,
  [Types.GET_CUSTOMERS_FOR_CONTROLLER_REQUEST_FAILURE]: getCustomersForControllerRequestFailure,
});

export const ControllersTypes = Types;
export default Creators;
